import * as React from 'react'
import cx from 'classnames'
import styles from './NotificationBar.sass'

interface NotificationBarProps {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBar = ({
  children,
  dataTest,
}: NotificationBarProps) => {
  return (
    <div className={styles.root} data-test={dataTest}>
      {children}
    </div>
  )
}

interface NotificationBarTitleProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBarTitle = ({
  children,
  dataTest,
  ...rest
}: NotificationBarTitleProps) => (
  <span
    className={cx(styles.text, styles.title)}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </span>
)

interface NotificationBarSubTitleProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBarSubTitle = ({
  children,
  dataTest,
  ...rest
}: NotificationBarSubTitleProps) => (
  <span
    className={cx(styles.text, styles.subTitle)}
    data-test={dataTest}
    {...rest}
  >
    {children}
  </span>
)

interface NotificationBarActionProps
  extends React.HTMLAttributes<HTMLSpanElement> {
  children?: React.ReactNode
  dataTest?: string
}

export const NotificationBarAction = ({
  children,
  dataTest,
  ...rest
}: NotificationBarActionProps) => (
  <a className={cx(styles.text, styles.action)} data-test={dataTest} {...rest}>
    {children}
  </a>
)
